var map = {
	"./cateicon0_a.svg": "f035",
	"./cateicon1_a.svg": "2646",
	"./cateicon2_a.svg": "12ab",
	"./cateicon3_a.svg": "8fea",
	"./cateicon4_a.svg": "e876",
	"./cateicon5_a.svg": "944f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d6b";